// Les retours des lecteurs partent directement depuis le site (src/donnees/avis.ts
// et le service serveur/). Ce module garde le repli : quand ce service est
// indisponible, la page propose d'ouvrir la messagerie avec le message rédigé
// (lien « mailto: »).

/** Adresse du repli par messagerie ; null : pas de repli proposé. */
export const ADRESSE_AVIS: string | null = "clemence.benard@acta.asso.fr";

export interface Avis {
  /** Partie du site concernée, en clair ; vide si le retour est général. */
  partie: string;
  message: string;
  /** Nom ou structure, facultatif : un retour anonyme reste recevable. */
  auteur: string;
}

/** Le courriel tel qu'il sera proposé : objet et corps en texte brut. */
export function courrielAvis(avis: Avis, version: string): { objet: string; corps: string } {
  const objet = "[ParsadaMap] Retour sur le prototype";
  const lignes = [
    `Partie du site : ${avis.partie.trim() || "générale"}`,
    `Version : ${version}`,
    "",
    avis.message.trim(),
  ];
  if (avis.auteur.trim()) lignes.push("", `— ${avis.auteur.trim()}`);
  return { objet, corps: lignes.join("\n") };
}

/** Lien « mailto: » ; encodeURIComponent et non URLSearchParams, qui coderait les espaces en « + ». */
export function lienAvis(adresse: string, avis: Avis, version: string): string {
  const { objet, corps } = courrielAvis(avis, version);
  return (
    `mailto:${encodeURIComponent(adresse)}` +
    `?subject=${encodeURIComponent(objet)}&body=${encodeURIComponent(corps)}`
  );
}
